import React from 'react';
import ValidatedFormInput from 'components/ValidatedFormInput';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { Button, Divider, Form, Header, Segment } from 'semantic-ui-react';
import {
  closeUserMappingDetails,
  openDeleteUserMappingModal,
  setUserMappingSearchKeyword,
  updateUserMapping,
} from 'state/userMapping/actions';
import {
  idEmptyValidation,
  idNumberValidation,
  emailValidation,
  phoneValidation,
  dateValidation,
} from 'utils/userMappingFormUtils';

const UserMappingDetail = props => {
  const {
    dispatch,
    activeUserIndex,
    userMappingDetails,
    userMapping,
    handleSubmit,
  } = props;

  const handleOnCancelButtonClick = () => {
    dispatch(closeUserMappingDetails());
  };

  const handleOnDeleteButtonClick = () => {
    dispatch(openDeleteUserMappingModal());
  };

  const handleOnSaveButtonClick = ({
    mokaUserId,
    hermesId,
    email,
    phoneNumber,
    confirmedAt,
  }) => {
    const payload = {
      moka_user_id: mokaUserId,
      hermes_id: hermesId,
      email: email !== '' ? email : null,
      phone_number: phoneNumber !== '' ? phoneNumber : null,
      confirmed_at: confirmedAt !== '' ? confirmedAt : null,
    };
    dispatch(updateUserMapping(payload));
    dispatch(closeUserMappingDetails());
    dispatch(
      setUserMappingSearchKeyword(userMapping.data[activeUserIndex].email)
    );
  };

  return (
    <>
      {activeUserIndex !== -1 && userMappingDetails ? (
        <>
          <Form onSubmit={handleSubmit(handleOnSaveButtonClick)}>
            <Segment secondary padded attached="top">
              <Header>User Mapping</Header>
              <Divider clearing />
              <label>Moka User ID</label>
              <Field
                id="mokaUserId"
                name="mokaUserId"
                component={ValidatedFormInput}
                disabled
              />
              <label>Moka Email</label>
              <Field
                id="mokaEmail"
                name="mokaEmail"
                component={ValidatedFormInput}
                disabled
              />
              <label>Moka Phone</label>
              <Field
                id="mokaPhone"
                name="mokaPhone"
                component={ValidatedFormInput}
                disabled
              />
              <label>Go User ID</label>
              <Field
                id="hermesId"
                name="hermesId"
                component={ValidatedFormInput}
                validate={[idEmptyValidation, idNumberValidation]}
                type="number"
              />
              <label>Go Email</label>
              <Field
                id="email"
                name="email"
                component={ValidatedFormInput}
                validate={[emailValidation]}
              />
              <label>Go Phone</label>
              <Field
                id="phoneNumber"
                name="phoneNumber"
                component={ValidatedFormInput}
                validate={[phoneValidation]}
              />
              <label>Confirmed At</label>
              <Field
                id="confirmedAt"
                name="confirmedAt"
                component={ValidatedFormInput}
                validate={[dateValidation]}
              />
            </Segment>
            <Segment tertiary padded clearing attached="bottom">
              <Button
                type="button"
                floated="left"
                color="blue"
                onClick={handleOnCancelButtonClick}
              >
                Close
              </Button>
              <Button type="submit" floated="right" color="blue">
                Save
              </Button>
              <Button
                type="button"
                floated="right"
                color="red"
                onClick={handleOnDeleteButtonClick}
                disabled={userMapping.data[activeUserIndex].hermes === null}
              >
                Delete
              </Button>
            </Segment>
          </Form>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = ({ userMapping }) => ({
  userMapping: userMapping.userMapping,
  activeUserIndex: userMapping.userMapping.activeIndex,
  userMappingDetails: userMapping.userMappingDetails,
  initialValues: {
    mokaUserId:
      userMapping.userMapping.data[userMapping.userMapping.activeIndex].id,
    mokaEmail:
      userMapping.userMapping.data[userMapping.userMapping.activeIndex].email,
    mokaPhone:
      userMapping.userMapping.data[userMapping.userMapping.activeIndex].phone,
    hermesId: userMapping.userMapping.data[userMapping.userMapping.activeIndex]
      .hermes
      ? userMapping.userMapping.data[userMapping.userMapping.activeIndex].hermes
          .id
      : null,
    email: userMapping.userMapping.data[userMapping.userMapping.activeIndex]
      .hermes
      ? userMapping.userMapping.data[userMapping.userMapping.activeIndex].hermes
          .email
      : null,
    phoneNumber: userMapping.userMapping.data[
      userMapping.userMapping.activeIndex
    ].hermes
      ? userMapping.userMapping.data[userMapping.userMapping.activeIndex].hermes
          .phone_number
      : null,
    confirmedAt: userMapping.userMapping.data[
      userMapping.userMapping.activeIndex
    ].hermes
      ? userMapping.userMapping.data[userMapping.userMapping.activeIndex].hermes
          .confirmed_at
      : null,
  },
});

UserMappingDetail.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  userMapping: PropTypes.object.isRequired,
  activeUserIndex: PropTypes.number.isRequired,
  userMappingDetails: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'user_mapping_form',
    enableReinitialize: true,
  })(UserMappingDetail)
);
